const actions = {
  chats: [],
  viewListSupervisors: false,
};

export default actions;
